export default "__VITE_ASSET__Dw5nDxrK__"